import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import * as React from 'react';
import { SCAState, SCAType } from './adyen_sca_hook';
import SCAChallengeShopper from './sca_challenge_shopper';
import SCAIdentifyShopper from './sca_identify_shopper';

interface Props {
  action: PaymentAction;
  onChallengeShopperComplete(challengeResult: string): void;
  onIdentifyShopperComplete(fingerprint: string): void;
}

const identifyShopper: SCAType = 'threeDS2Fingerprint';
const challengeShopper: SCAType = 'threeDS2Challenge';

export default function SCAInteraction(props: Props) {
  function onAdditionalDetails(state: SCAState) {
    if (state.data.details['threeds2.fingerprint']) {
      props.onIdentifyShopperComplete(state.data.details['threeds2.fingerprint']);
    } else {
      props.onChallengeShopperComplete(state.data.details['threeds2.challengeResult']);
    }
  }

  if (props.action.type === identifyShopper) {
    return <SCAIdentifyShopper action={props.action} onAdditionalDetails={onAdditionalDetails} />;
  }

  if (props.action.type === challengeShopper) {
    return <SCAChallengeShopper action={props.action} onAdditionalDetails={onAdditionalDetails} />;
  }

  return null;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/sca_interaction.tsx